import getAdditionalCustomerSaga from './getAdditionalCustomer';
import getCustomerRequiredDetailsSaga from './getCustomerRequiredDetails';
import getCustomerSaga from './getCustomer';
import updateAdditionalCustomerSaga from './updateAdditionalCustomer';
import updateCustomerDeliveriesSaga from './updateCustomerDeliveries';
import updateCustomerSaga from './updateCustomer';

export const customerSagas = [
  getAdditionalCustomerSaga,
  getCustomerRequiredDetailsSaga,
  getCustomerSaga,
  updateAdditionalCustomerSaga,
  updateCustomerSaga,
  updateCustomerDeliveriesSaga,
];
